import React, { Component } from "react";
import { Link } from "react-router-dom";
import { getCustomerOrder } from "../../actions";
import { connect } from "react-redux";
import moment from "moment";
import { map } from "lodash";

class CustomerOrder extends Component {
  componentDidMount() {
    const orderId = this.props.match.params.id;
    this.props.getCustomerOrder(orderId);
  }

  render() {
    let obj =
      this.props.data && this.props.data.orders
        ? this.props.data.orders[this.props.match.params.id]
        : "";

    return (
      <React.Fragment>
        <div className="page-title">
          <div className="container">
            <div className="row flex-center-y justify-between">
              <div className="col-xs-12 text-center">
                <h1 className="color-grey">Single Order</h1>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          {/* START: Breadcrumb Component */}
          <ul className="breadcrumb">
            <li>
              <Link to="/customer-orders">Customer Orders</Link>
            </li>
            <li>Single Order</li>
          </ul>
          {/* END: Breadcrumb Component */}
        </div>

        <div className="container box inner-padding mb-15">
          <div className="box-body">
            <div className="row justify-between">
              <div className="col-xs-6 pr-70">
                <ul className="w-700">
                  <li className="py-15">
                    <p className="font-sm color-grey50">Order ID</p>
                    <p className="color-primary mt-5">{obj.id}</p>
                  </li>
                  <li className="py-15">
                    <p className="font-sm color-grey50">Order Date/Time</p>
                    <p className="color-primary mt-5">
                      {moment(obj.created).format("MM-DD-YYYY HH:mm")}
                    </p>
                  </li>
                  <li className="py-15">
                    <p className="font-sm color-grey50">Order Details</p>
                    {map(obj.orderItems, data => {
                      return (
                        <ul className="tags mt-5" key={data.id}>
                          <li>
                            {data.itemName}
                            <span className="divider" />
                            <span className="w-700 color-grey50">
                              {data.itemCount * data.itemPrice} pcs
                            </span>
                          </li>
                        </ul>
                      );
                    })}
                  </li>
                  <li className="py-15">
                    <p className="font-sm color-grey50">Total Order Cost</p>
                    <p className="color-primary mt-5">{obj.orderSum} SAR</p>
                  </li>
                  <li className="py-15">
                    <p className="font-sm color-grey50">
                      Defined Delivery Time
                    </p>
                    <p className="color-primary mt-5">{obj.deliveryTime}</p>
                  </li>
                </ul>
              </div>
              <div className="col-xs-6 pl-70">
                <ul className="w-700">
                  <li className="py-15">
                    <p className="font-sm color-grey50">Driver ID</p>
                    <p className="color-primary mt-5">{obj.driverId}</p>
                  </li>
                  <li className="py-15">
                    <p className="font-sm color-grey50">Driver First Name</p>
                    <p className="color-primary mt-5">{obj.driverFirstName}</p>
                  </li>
                  <li className="py-15">
                    <p className="font-sm color-grey50">Driver Last Name</p>
                    <p className="color-primary mt-5">{obj.driverLastName}</p>
                  </li>
                  <li className="py-15">
                    <p className="font-sm color-grey50">Driver Mobile Number</p>
                    <p className="color-primary mt-5">
                      {obj.driverPhoneNumber}
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    data: state.foodna
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getCustomerOrder: id => dispatch(getCustomerOrder(id))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomerOrder);



// WEBPACK FOOTER //
// ./src/components/Customer-web-portal/CustomerOrder.js